/* eslint-disable import/no-webpack-loader-syntax */
import Content from "!babel-loader!@mdx-js/loader!../docs/agreement.mdx";

export default function agreement() {
  return <Content />;
}
